import { type Currency } from "@vega-api/generated/types/currency";
import { type DealTrackingLimitedPartnerBreakdown } from "@vega-api/generated/types/dealTrackingLimitedPartnerBreakdown";
import { type DealTrackingMetric } from "@vega-api/generated/types/dealTrackingMetric";
import { type Money } from "@vega-api/generated/types/money";

import { AllocationSummaryPanel } from "../components/AllocationSummaryPanel/AllocationSummaryPanel";
import { TrackAllocationTable } from "../components/TrackAllocationTable/TrackAllocationTable";

type AllocationViewProps = {
  dealId: string;
  dealCurrency: Currency;
  fundContributionAmount?: Money;
  metrics: DealTrackingMetric[];
  limitedPartnerBreakdown: DealTrackingLimitedPartnerBreakdown[];
  isLoading: boolean;
};

export const AllocationView = ({
  dealId,
  dealCurrency,
  fundContributionAmount,
  metrics,
  limitedPartnerBreakdown,
  isLoading,
}: AllocationViewProps) => (
  <>
    <AllocationSummaryPanel
      dealCurrency={dealCurrency}
      dealId={dealId}
      fundContributionAmount={fundContributionAmount}
      isLoading={isLoading}
      metrics={metrics}
    />
    <div className="space-y-4 pb-52">
      <TrackAllocationTable
        data={limitedPartnerBreakdown}
        dealCurrency={dealCurrency}
        dealId={dealId}
        isLoading={isLoading}
      />
    </div>
  </>
);
